<template>
    <header>
        <section class="bottom">
            <div class="bottom-title">
                <p>Compare</p>
            </div>
        </section>
    </header>
    <div id="CostStudy_Grid_Area" style="display: none; padding: 3px 0">
        <ejs-grid ref="costStudyGrid" :selectionSettings='selectionOptions' :toolbarClick='costStudyToolBar' :dataSource='costStudyGrid.data' 
                  :toolbar='costStudyGrid.toolbar' :allowSearching="true" :allowPaging="true" :allowSorting='true' :allowTextWrap="true">
            <e-columns>
                <e-column type='checkbox' width='50'></e-column>
                <e-column field='Id' headerText='Id' :isPrimaryKey='true'></e-column>
                <e-column field='EcrNumber' headerText='ECR Number'></e-column>
                <e-column field='Name' headerText='Cost Study Name' width="75%"></e-column>
            </e-columns>
        </ejs-grid>
    </div>
    <div id="Version_Grid_Area" style="display: none; padding: 3px 0">
        <ejs-grid ref="versionGrid" :groupSettings='versionGridGroupOptions'  :allowGrouping='true' :selectionSettings='selectionOptions' 
                  :toolbarClick='versionToolBar' :dataSource='versionGrid.data' :toolbar='versionGrid.toolbar' :allowSearching="true" :allowPaging="true" :allowSorting='true' :allowTextWrap="true">
            <e-columns>
                <e-column type='checkbox' width='50'></e-column>
                <e-column field='id' headerText='Id' :isPrimaryKey='true'></e-column>
                <e-column field='costStudyId' headerText='Cost Study'></e-column>
                <e-column field='Name' headerText='Version Name' width="75%"></e-column>
            </e-columns>
        </ejs-grid>
    </div>
    <div id="Option_Grid_Area" style="display: none; padding: 3px 0">
        <ejs-grid ref="optionGrid" :groupSettings='optionGridGroupOptions'  :allowGrouping='true' :selectionSettings='selectionOptions'  
                  :toolbarClick='optionToolBar' :dataSource='optionGrid.data' :toolbar='optionGrid.toolbar' :allowSearching="true" :allowPaging="true" :allowSorting='true' :allowTextWrap="true">
            <e-columns>
                <e-column type='checkbox' width='50'></e-column>
                <e-column field='id' headerText='Id' :isPrimaryKey='true'></e-column>
                <e-column field='GroupName' headerText='Option Name'></e-column>
                <e-column field='costStudyId' headerText='Cost Study'></e-column>
                <e-column field='version.Name' headerText='Version Name'></e-column>
            </e-columns>
        </ejs-grid>
    </div>
    <div id="SaleableParts_Grid_Area" style="display: none; padding: 3px 0">
        <ejs-grid ref="saleablePartGrid" :groupSettings='saleablePartGridGroupOptions' :allowGrouping='true' :selectionSettings='selectionOptions' 
                  :toolbarClick='saleablePartToolBar' :dataSource='saleablePartGrid.data' :toolbar='saleablePartGrid.toolbar' :allowSearching="true" :allowPaging="true" :allowSorting='true' :allowTextWrap="true">
            <e-columns>
                <e-column type='checkbox' width='50'></e-column>
                <e-column field='id' headerText='Id'></e-column>
                <e-column field='partNumber' headerText='Part #'></e-column>
                <e-column field='revision' headerText='Part Revision'></e-column>
                <e-column field='suffix' headerText='Part Suffix'></e-column>
                <e-column field='name' headerText='Part Name'></e-column>
                <e-column field='optionName' headerText='Option Name'></e-column>
                <e-column field='costStudyId' headerText='Cost Study'></e-column>
                <e-column field='version.Name' headerText='Version Name'></e-column>
                <e-column field='index' headerText='Index' :isPrimaryKey="true" :visible=false></e-column>
            </e-columns>
        </ejs-grid>
    </div>


    <ejs-accordion expandMode='Single' ref="accordion">
        <e-accordionitems>
            <e-accordionitem expanded='true' header='Cost Studies' content='#CostStudy_Grid_Area'>
            </e-accordionitem>
            <e-accordionitem header='Versions' content='#Version_Grid_Area' isHidden="true">
            </e-accordionitem>
            <e-accordionitem header='Options' content='#Option_Grid_Area'>
            </e-accordionitem>
            <e-accordionitem header='Saleable Parts' content='#SaleableParts_Grid_Area'>
            </e-accordionitem>
        </e-accordionitems>
    </ejs-accordion>
</template>

<script>
    import { GridComponent, ColumnsDirective, ColumnDirective } from '@syncfusion/ej2-vue-grids';
    import { AccordionComponent, AccordionItemDirective, AccordionItemsDirective } from "@syncfusion/ej2-vue-navigations";
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import api from '../modules/ApiClient';
    import Session from "../modules/Session";
    import Config from '../modules/Config';
    import { ReportNames, GridArgumentNames, Routes } from '../modules/Constants';

    export default {
        name: 'CompareComponent',
        props: {
            msg: String
        },
        components: {
            'ejs-grid': GridComponent,
            'e-columns': ColumnsDirective,
            'e-column': ColumnDirective,
            "ejs-accordion": AccordionComponent,
            "e-accordionitems": AccordionItemsDirective,
            "e-accordionitem": AccordionItemDirective,
        },
        methods: {
            costStudyToolBar: function (args) {
                if (args.item.id === GridArgumentNames.VERSIONS) {
                    let selectedStudies = this.$refs.costStudyGrid.ej2Instances.getSelectedRecords();
                    if (selectedStudies?.length <= this.maxOptions) {
                        this.selectedCostStudies = selectedStudies;


                        if (this.selectedCostStudies.length != 0) {
                            let versions = [];
                            this.selectedCostStudies.forEach(study => {
                                versions.push(new Promise(function (resolve, reject) {
                                    Session.WaitToBeAuthenticated(() => {
                                        api.GetAvailableVersions(study.Id).then((response) => {
                                            var data = response.map((item) => {
                                                return {
                                                    id: item.Version.id,
                                                    Name: item.Version.Name,
                                                    costStudyId: item.Version.costStudyId
                                                };
                                            });
                                            if (data) {
                                                resolve(data);
                                            } else {
                                                reject([])
                                            }
                                        });
                                    });
                                }));
                            });

                            Promise.all(versions).then(values => {
                                let versions = values.reduce(function (a, b) { return a.concat(b) }, []);
                                this.versionGrid.data = versions;
                                this.$refs.accordion.hideItem(1, false);
                                this.$refs.accordion.expandItem(false, 0);
                                this.$refs.accordion.expandItem(true, 1);
                            });
                        }
                    } else {
                        this.maxOptionsError();
                    }
                   
                }
            },
            versionToolBar: function (args) {
                let selectedVersions = this.$refs.versionGrid.ej2Instances.getSelectedRecords();
                if (args.item.id === GridArgumentNames.OPTIONS) {
                    if (selectedVersions.length <= this.maxOptions) {
                        this.selectedVersions = selectedVersions;


                        if (this.selectedVersions.length != 0) {
                            let options = [];
                            this.selectedVersions.forEach(version => {
                                options.push(new Promise(function (resolve, reject) {
                                    Session.WaitToBeAuthenticated(() => {
                                        api.GetSnapshots(version.costStudyId, version.id).then((response) => {
                                            response.forEach(val => {
                                                val.version = version;
                                            })
                                            if (response) {
                                                resolve(response);
                                            } else {
                                                reject([])
                                            }
                                        });
                                    });
                                }));
                            });

                            Promise.all(options).then(values => {
                                let options = values.reduce(function (a, b) { return a.concat(b) }, []);
                                this.optionGrid.data = options;
                                this.$refs.accordion.hideItem(2, false);
                                this.$refs.accordion.expandItem(false, 0);
                                this.$refs.accordion.expandItem(false, 1);
                                this.$refs.accordion.expandItem(true, 2);
                            });
                        }
                    } else {
                        this.maxOptionsError();
                    }
                }
                if (args.item.id === GridArgumentNames.PROFIT_AND_LOSS) {
                    let baseRoute = Routes.PROFIT_AND_LOSS_COMPARISON;
                    let baseReportName = ReportNames.PROFIT_AND_LOSS;
                 

                    if (selectedVersions?.length <= this.maxOptions) {
                        if (selectedVersions?.length >= 2) {
                            let query = {};
                            query.costStudies = [... new Set(selectedVersions.map(version => version.costStudyId))];
                            query.versions = [... new Set(selectedVersions.map(version => version.id))];

                            this.$router.push({
                                path: baseRoute, query: query
                            });
                        }

                        if (selectedVersions?.length < 2) {
                            DialogUtility.alert({
                                title: 'Error',
                                content: `Please select 2 or more Versions to view the ${baseReportName}`,
                                okButton: { text: 'OK', click: function () { this.hide() } },
                                showCloseIcon: true,
                                closeOnEscape: false,
                                animationSettings: { effect: 'Zoom' }
                            });
                        }
                    }
                    else {
                        this.maxOptionsError();
                    }
                }
            },
            optionToolBar: function (args) {
                let selectedOptions = this.$refs.optionGrid.ej2Instances.getSelectedRecords();
                if (args.item.id === GridArgumentNames.SALEABLE_PARTS) {
                    if (selectedOptions?.length <= this.maxOptions) {
                        this.selectedOptions = selectedOptions;

                        if (this.selectedOptions.length != 0) {

                            let saleableParts = [];
                            this.selectedOptions.forEach(option => {
                                option.SaleableParts?.forEach((saleablePart) => {
                                    let sp = {};
                                    sp.version = option.version
                                    sp.optionName = option.GroupName
                                    sp.costStudyId = option.costStudyId;
                                    sp.partNumber = saleablePart?.Part?.Number?.Fields[0];
                                    sp.revision = saleablePart?.Part?.DrawingRevision?.Fields[0]?.Fields[0];
                                    sp.id = saleablePart?.Id;
                                    sp.suffix = saleablePart?.Part?.Suffix?.Fields[0]?.Fields[0];
                                    sp.name = saleablePart?.Name?.Value?.Fields[0];
                                    saleableParts.push(sp);
                                })
                            })

                            saleableParts.forEach((sp, rowIndex) => {
                                sp.index = rowIndex;
                            })

                            this.saleablePartGrid.data = saleableParts;
                            this.$refs.accordion.hideItem(3, false);
                            this.$refs.accordion.expandItem(false, 0);
                            this.$refs.accordion.expandItem(false, 1);
                            this.$refs.accordion.expandItem(false, 2);
                            this.$refs.accordion.expandItem(true, 3);
                        }
                    }
                    else {
                        this.maxOptionsError();
                    }
                }
                if (args.item.id === GridArgumentNames.BUSINESS_CASE_COMPARISON || args.item.id === GridArgumentNames.SALEABLE_COMPARISON) {
                    let baseRoute = "";
                    let baseReportName = "";

                    if (args.item.id === GridArgumentNames.SALEABLE_COMPARISON) {
                        baseRoute = Routes.SALEABLE_COMPARISON
                        baseReportName = ReportNames.SALEABLE_COMPARISON
                    }
                    else {
                        baseRoute = Routes.BUSINESS_CASE_COMPARISON
                        baseReportName = ReportNames.BUSINESS_CASE_COMPARISON
                    }

                    if (selectedOptions?.length <= this.maxOptions) {
                        if (selectedOptions?.length >= 2) {
                            let query = {};
                            query.costStudies = [... new Set(selectedOptions.map(option => option.version.costStudyId))];
                            query.versions = [... new Set(selectedOptions.map(option => option.version.id))];
                            query.options = [... new Set(selectedOptions.map(option => option.id))];

                            this.$router.push({
                                path: baseRoute, query: query
                            });
                        }

                        if (selectedOptions?.length < 2) {
                            DialogUtility.alert({
                                title: 'Error',
                                content: `Please select 2 or more Options to view the ${baseReportName}`,
                                okButton: { text: 'OK', click: function () { this.hide() } },
                                showCloseIcon: true,
                                closeOnEscape: false,
                                animationSettings: { effect: 'Zoom' }
                            });
                        }
                    }
                    else {
                        this.maxOptionsError();
                    }
                }
            },
            saleablePartToolBar: function (args) {
                if (args.item.id === GridArgumentNames.COMPONENT_WALK) {
                    let selectedSaleableParts = this.$refs.saleablePartGrid.ej2Instances.getSelectedRecords();

                    if (selectedSaleableParts?.length <= this.maxOptions) {
                        if (selectedSaleableParts?.length >= 2) {
                            //Example: part=3035016001%7C5e300d14-bead-48bb-9c29-5a803988dd65%7CA%7C38267560
                            let query = { part: selectedSaleableParts.map(x => `${x.costStudyId}|${x.version.id}|${x.optionName}|${x.partNumber}`)}

                            this.$router.push({
                                path: Routes.COMPONENT_WALK, query 
                            });
                        }
                    } else {
                        this.maxOptionsError();
                    }
                }
        },
            maxOptionsError: function () {
                DialogUtility.alert({
                    title: 'Error',
                    content: 'Please select no more than 10 items!',
                    okButton: { text: 'OK', click: function () { this.hide() } },
                    showCloseIcon: true,
                    closeOnEscape: false,
                    animationSettings: { effect: 'Zoom' }
                });
            }
        },
        data() {
            return {
                maxOptions: 10,
                selectionOptions: { persistSelection: true },
                costStudyGrid: {
                    data: [],
                    toolbar: [
                        { text: 'View Versions', tooltipText: 'Versions', id: `${GridArgumentNames.VERSIONS}`, prefixIcon: 'e-grid-view' },
                        'Search'
                    ]
                },
                versionGrid: {
                    data: [],
                    toolbar: [
                        { text: 'View Options', tooltipText: 'Options', id: `${GridArgumentNames.OPTIONS}`, prefixIcon: 'e-grid-view' },
                        { text: `${ReportNames.PROFIT_AND_LOSS}`, tooltipText: `${ReportNames.PROFIT_AND_LOSS}`, id: `${GridArgumentNames.PROFIT_AND_LOSS}`, prefixIcon: 'e-table-2' },
                        'Search'
                    ]
                },
                optionGrid: {
                    data: [],
                    toolbar: [
                        { text: 'View Saleable Parts', tooltipText: 'Saleable Parts', id: `${GridArgumentNames.SALEABLE_PARTS}`, prefixIcon: 'e-grid-view' },
                        { text: `${ReportNames.BUSINESS_CASE_COMPARISON}`, tooltipText: `${ReportNames.BUSINESS_CASE_COMPARISON}`, id: `${GridArgumentNames.BUSINESS_CASE_COMPARISON}`, prefixIcon: 'e-table-2' },
                        { text: `${ReportNames.SALEABLE_COMPARISON}`, tooltipText: `${ReportNames.SALEABLE_COMPARISON}`, id: `${GridArgumentNames.SALEABLE_COMPARISON}`, prefixIcon: 'e-table-2' },
                        'Search'
                    ]
                },
                saleablePartGrid: {
                    data: [],
                    toolbar: [
                        { text: `${ReportNames.COMPONENT_WALK}`, tooltipText: `${ReportNames.COMPONENT_WALK}`, id: `${GridArgumentNames.COMPONENT_WALK}`, prefixIcon: 'e-table-2' },
                        'Search'
                    ]
                },
                versionGridGroupOptions: {
                    showDropArea: false, columns: ['costStudyId']
                },
                optionGridGroupOptions: {
                    showDropArea: false, columns: ['costStudyId', 'version.Name']
                },
                saleablePartGridGroupOptions: {
                    showDropArea: false, columns: ['costStudyId', 'version.Name', 'optionName']
                },
                selectedCostStudies: null,
                selectedVersions: null,
                selectedOptions: null,
            };
        },
        mounted() {
            this.$refs.accordion.hideItem(1);
            this.$refs.accordion.hideItem(2);
            this.$refs.accordion.hideItem(3);

            if (Config.Provider("showBusinessCaseCompare") == false) {
                this.optionGrid.toolbar = [
                    { text: 'View Saleable Parts', tooltipText: 'Saleable Parts', id: `${GridArgumentNames.SALEABLE_PARTS}`, prefixIcon: 'e-grid-view' },
                    'Search'
                ];
            }

            Session.WaitToBeAuthenticated(() => {
                api.GetCostStudies().then((response) => {
                    this.costStudyGrid.data = response;
                });
            });
        }
    }
</script>
